import { createSelector } from '@reduxjs/toolkit';
import { selectAvailableBanks } from './selectAvailableBanks';

export const selectBankTitlesToIdsMap = createSelector([selectAvailableBanks], banks => {
  const result: Record<string, number> = {};

  for (const bank of banks) {
    result[bank.title] = bank.id;
  }

  return result;
});
